<template>
	<PrimaryButton
		@click="$emit('show-widget-menu')"
		class="add-new-element-container display-flex flex-row flex-centerize px-2"
		style="background: var(--button-background) !important; border: 1px solid var(--button-border) !important"
	>
		<SIcon name="add-field-new" class="add-field-btn-content" />
		<div class="pl-2">New block</div>
	</PrimaryButton>
</template>
<script>
export default {
	name: 'AddNewWidgetElement',
};
</script>

<style scoped lang="scss">
.add-new-element-container {
	height: 36px !important;
	font-size: 12px !important;
	color: var(--button-text) !important;
}

.add-field-btn-content {
	width: 19px;
	height: 19px;
	border-radius: 50%;
	box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
}
</style>
